// extracted by mini-css-extract-plugin
export default {"container":"localization-changer_container__AxSNp","option":"localization-changer_option__WdnUd","optionXs":"localization-changer_optionXs__nBdJN"};